import axios from 'axios';
import { CPJSONURL } from '../common/const';
const instance = axios.create({
  // キャンペーン一覧json URLを定義する
  baseURL: CPJSONURL + new Date().getTime()
});
export default instance;
